// Centralized regex constants and small helpers for markdown parsing and policy references

// Basic markdown
export const BOLD_MD_RE = /\*\*(.*?)\*\*/g
export const ITALIC_MD_RE = /\*(.*?)\*/g
export const STRIKE_MD_RE = /~~(.*?)~~/g
export const INLINE_CODE_MD_RE = /`([^`]+)`/g

// Links and email
export const POLICY_ANCHOR_MD_RE = /\[([^\]]+)\]\(#([A-Z0-9_-]+)\)/gi
export const ACTION_LINK_MD_RE = /\[([^\]]*)\]\(#action:([^)\n]+)(?:\)|$)/gi
export const LINK_MD_RE = /\[([^\]]+)\]\(([^)]+)\)/g
export const EMAIL_ANGLE_RE = /<([^>]+@[^>]+)>/g

// Policy code extraction patterns (support optional leading '#', e.g. (#BZSF00004_v4_0822))
export const PAREN_POLICY_CODE_RE = /\(#?([A-Za-z0-9_-]{4,})\)/g
export const PAREN_LABELED_POLICY_CODE_RE =
  /\((?:Policy\s*Code|Policy\s*code)\s*:\s*#?([A-Za-z0-9_-]{4,})\)/g
export const INLINE_POLICY_CODE_RE =
  /(^|\s)(?:Policy\s*Code|Policy\s*code)\s*:\s*#?([A-Za-z0-9_-]{4,})\b/g
export const POLICY_LINK_HTML_RE = /class="policy-page-link"[^>]+data-policy-code="([^"]+)"/gi

// Page reference (e.g. "Part A page 24", "page 24")
export const PAGE_REF_RE = /(?:[Pp]art\s+[A-Za-z]+\s+)?[Pp]age\s+\d{1,4}/g

// Structural lines
export const HORIZONTAL_RULE_RE = /^[\s]*[-*_]{3,}[\s]*$/
export const TABLE_SEPARATOR_ROW_RE = /^[\s|:-]+$/
export const ORDERED_LIST_START_RE = /^\d+\.\s/

// Helper to get nearest page reference before an offset
export function findNearestPageRefBefore(text: string, offset: number): string {
  const before = text.slice(0, offset)
  let lastRef: string | undefined
  let match: RegExpExecArray | null
  const re = new RegExp(PAGE_REF_RE.source, PAGE_REF_RE.flags)
  while ((match = re.exec(before)) !== null) lastRef = match[0]
  return lastRef ?? ''
}
